import { QueryKey, useQuery } from '@tanstack/react-query';

import { useAuth, UserPermissions } from '@arrived/auth';

import { UseQueryOptions } from '../queries.utils';

export function usePermissionsQuery(options?: UseQueryOptions<UserPermissions[]>) {
  const { isAuthenticated, getPermissions } = useAuth();

  return useQuery(['currentUser', 'permissions'] as QueryKey, async () => getPermissions(), {
    ...options,
    enabled: (options?.enabled ?? true) && isAuthenticated,
  });
}
